import template from './file-upload.html';
import controller from './file-upload.controller';

import './file-upload.styl';

let fileUploadComponent = {
  restrict: 'E',
  bindings: {
      fileName: '@',
      inline: '@'
  },
  template,
  controller
};

export default fileUploadComponent;



// WEBPACK FOOTER //
// ./client/app/common/file-upload/file-upload.component.js